import './index.css'
import img1 from '../../resources/Dialog1-2.png';
import img2 from '../../resources/Dialog3-4.png';
import img3 from '../../resources/Dialog5-6.png';

export default function Dialog() {
    return (
      <div className="dialog">

           {/* Hero Section */}
<div className="hero-section">
    <div className="hero-overlay">
        <div className="hero-content" data-aos="fade-up">
            <h1 className="hero-title">
                Facilitated Dialogue <br/>for a Sustainable Future
            </h1>
            <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
                Engage in collaborative reflection on sustainability scenarios, as experienced in VR. 
                Guided by a mobile app, discuss individually and in groups to shape a shared vision for the future.
            </p>
        </div>
        {/* Button at the bottom */}
        <div className="hero-button-container mt-5" data-aos="fade-up" data-aos-delay="400">
            <a href="https://chess1.karpathos.net/dev/story-player/c4313c264e0a895e11461eb5c001a541" 
               className="hero-button">
                version 1.0 Greek (alpha)
            </a>
        </div>
    </div>
</div> 

            {/* Content 
            <div className="flex items-center justify-center px-4 mx-5 mr-20 ml-20">
                <p className="text-white text-lg md:text-xl mt-4 leading-relaxed" data-aos="fade-up" data-aos-delay="200">
                    The facilitated dialogue experience aims to stimulate collaborative reflection and dialogue on the different scenarios and pathways to a sustainable future,  as experienced in the VR. The activity is guided by a mobile app created with the Narralive Story Maker interactive narratives creation tool [url].  The application guides the users through the experience, which interleaves parts of individual exploration and parts where the group is prompted to discuss specific topics.
                </p>
            </div>
            */}
            <div className='dialog-item left' data-aos="fade-right">
                <img src={img1} alt="example"/>
                <p className="text-xl md:text-2xl">The facilitated dialogue tool guides meaningful conversations about climate change in Athens and Nature Based Solutions.</p>
            </div>
            <div className="dialog-item right" data-aos="fade-left" >
                <p className="text-xl md:text-2xl">The tool combines text and multimedia that create a more engaging dialogic experience.</p>
                <img src={img2} alt="example" />
            </div>
            <div className='dialog-item left' data-aos="fade-right">
                <img src={img3} alt="example"/>
                <p className="text-xl md:text-2xl">Questions stimulate sharing of personal views. <br/> By exploring different perspectives, participants gain a deeper understanding of climate change and its potential solutions!</p>
            </div>
        </div> 
    );
}